import { render } from "./VirtualTour.vue?vue&type=template&id=5499a002&scoped=true"
import script from "./VirtualTour.vue?vue&type=script&lang=js"
export * from "./VirtualTour.vue?vue&type=script&lang=js"

import "./VirtualTour.vue?vue&type=style&index=0&id=5499a002&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5499a002"]])

export default __exports__